<template>
    <b-modal
        id="modal-quick-category"
        :visible="value"
        title="Hızlı Kategori Ekle"
        size="md"
        no-close-on-backdrop
        @hidden="$emit('input', false)"
    >
        <b-form @submit.prevent="save">
            <b-form-group label="Kategori Anahtarı *">
                <b-form-input
                    v-model="form.categoryKey"
                    placeholder="services, solutions"
                />
            </b-form-group>

            <b-form-group label="Kategori Adı *">
                <b-form-input
                    v-model="form.categoryName"
                    placeholder="Hizmetler, Çözümler"
                />
            </b-form-group>

            <b-form-group label="Açıklama">
                <b-form-textarea
                    v-model="form.description"
                    rows="2"
                    placeholder="Kategori açıklaması"
                />
            </b-form-group>

            <b-row>
                <b-col md="6">
                    <b-form-group label="İkon">
                        <b-form-input
                            v-model="form.icon"
                            placeholder="FileTextIcon"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Sıra">
                        <b-form-spinbutton v-model="form.sortOrder" min="0" />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-form-checkbox v-model="form.isActive" switch>
                Aktif
            </b-form-checkbox>
        </b-form>

        <template #modal-footer>
            <b-button variant="secondary" @click="$emit('input', false)">
                İptal
            </b-button>
            <b-button variant="primary" :disabled="loading" @click="save">
                <b-spinner v-if="loading" small class="mr-50" />
                Kaydet
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import { BModal, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BFormSpinbutton, BButton, BRow, BCol, BSpinner } from 'bootstrap-vue';
import WebsiteApi from '@/api/website';

export default {
    name: 'QuickCategoryModal',
    components: {
        BModal, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox,
        BFormSpinbutton, BButton, BRow, BCol, BSpinner
    },
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            form: {
                categoryKey: '',
                categoryName: '',
                description: '',
                icon: '',
                sortOrder: 0,
                isActive: true
            }
        };
    },
    methods: {
        async save() {
            if (!this.form.categoryKey || !this.form.categoryName) {
                this.$toast.warning('Lütfen zorunlu alanları doldurun!');
                return;
            }

            this.loading = true;
            try {
                const payload = {
                    CategoryKey: this.form.categoryKey,
                    CategoryName: this.form.categoryName,
                    Description: this.form.description,
                    Icon: this.form.icon,
                    SortOrder: this.form.sortOrder,
                    IsActive: this.form.isActive
                };

                const response = await WebsiteApi.Category.Create(payload);
                this.$result(response);

                if (response.data.Success) {
                    this.$emit('saved');
                    this.$emit('input', false);
                    this.resetForm();
                }
            } catch (error) {
                this.$result(null, error);
            } finally {
                this.loading = false;
            }
        },

        resetForm() {
            this.form = {
                categoryKey: '',
                categoryName: '',
                description: '',
                icon: '',
                sortOrder: 0,
                isActive: true
            };
        }
    }
};
</script>